import React from "react";
import { Link } from "react-router-dom";

function Sidedrawitem({ hidden, href, isActive, children, onClick,title }) {
  return onClick ? (
    <li hidden={hidden} className="sideBarIcons-list" title={title} onClick={onClick}>
      <Link>{children}</Link>
    </li>
  ) : (
    <li hidden={hidden} className="sideBarIcons-list" title={title}>
      <Link to={href}>{children}</Link>
    </li>
  );
}

export default Sidedrawitem;
